<template lang="pug">
  #GroupPushIndex
    h5.text-center.pt-2.mb-0
    .p-3
      b-card.border-0.mb-2.customerCard.overflow-hidden.position-relative(
        bg-variant="light",
        v-for="(user,index) in memberList",
        :key="user.member_id",
        v-if="memberList"
      )
        i.fas.fa-times-circle.fa-lg.position-absolute.text-danger(
          style="right: 10px;",
          @click="deletePushMemberHandler(user.member_id)"
        )
        label.w-100.mb-0(
          :for="`checkbox-group-${index}`"
        )
          .row.align-items-center.no-gutters
            .col-4.pr-1
              ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
                :profileUrl="user.picture_url",
                :style="{ 'width': '80px', 'height': '80px' }"
              )
            .col-8.pl-1
              p.mb-0.font-weight-bold 暱稱名 {{ user.line_display_name }}
              p.mb-0 備註名 {{ user.note_name ? user.note_name : '-' }}
      p.mb-0.text-center(
        v-if="!memberList || memberList.length === 0"
      ) 無選擇推播目標
    ChatGroupPushFooter.outline-none(
      v-if="memberList && memberList.length !== 0",
      @sendHandler="sendHandler"
    )

    SitckerModel(
      title="貼圖",
      @postSendApiHandler="postSendApiHandler"
    )

    TempModel(
      title="訊息模板",
      :multicastPush="true",
      :users="memberList"
    )

    TextPushModel(
      title="群發訊息",
      @sendHandler="sendHandler"
    )

    InvitationModel(
      title="邀請函",
      :multicastPush="true",
      :users="memberList"
    )
</template>

<script>
import { mapState } from 'vuex';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import ChatGroupPushFooter from '@/components/chat/ChatGroupPushFooter.vue';
import SitckerModel from '@/components/customerModel/stickerModel.vue';
import TextPushModel from '@/components/customerModel/textPushModel.vue';
import TempModel from '@/components/customerModel/tempModel.vue';
import InvitationModel from '@/components/customerModel/invitationModel.vue';
import JQuery from 'jquery';

const _ = require('lodash');

const $ = JQuery;

export default {
  name: 'GroupPushIndex',
  components: {
    ProfilePhotoSticker,
    ChatGroupPushFooter,
    SitckerModel,
    TempModel,
    TextPushModel,
    InvitationModel
  },
  created() {
    const vm = this;
    $('#home').animate({
      scrollTop: 0
    }, 10);
    vm.$store.commit('toggleLoading', false);
  },
  methods: {
    sendHandler(data) {
      const vm = this;
      if (!data || !data.type) return;

      switch (data.type) {
        case 'text':
          vm.postSendApiHandler(data);
          break;
        case 'image':
          vm.$swal.fire({
            title: '圖片上傳中，請稍候',
            allowOutsideClick: false,
            heightAuto: false,
            willOpen: () => {
              vm.$swal.showLoading();
            }
          });
          // 先上傳圖片, 之後再打 Post Chat Api
          vm.$store.dispatch('sm_chat/saveImgHandler', data.file.file)
            .then((res) => {
              if (res.length === 1) {
                vm.postSendApiHandler({
                  type: 'image',
                  file_id: res[0].data.file_id,
                  image: res[0].data.url
                });
              } else {
                vm.$swal.close();
                console.log('TODO: 群發！');
              }
            });
          break;
        case 'video':
          vm.$swal.fire({
            title: '影片上傳中，請稍候',
            allowOutsideClick: false,
            heightAuto: false,
            willOpen: () => {
              vm.$swal.showLoading();
            }
          });
           // 先上傳影片, 之後再打 Post Chat Api
          vm.$store.dispatch('sm_chat/saveVideoHandler', data.file.file)
            .then((res) => {
              vm.$swal.close();
              if (res.length === 1) {
                vm.postSendApiHandler({
                  type: 'video',
                  video: res[0].data.url,
                  previewImage: res[0].data.previewImage
                });
              } else {
                vm.$swal.close();
                console.log('TODO: 群發！');
              }
            });
          break;
        default:
          break;
      }
    },
    // 送出訊息
    postSendApiHandler(data) {
      const vm = this;
      // Loding
      vm.$swal.fire({
        title: '訊息送出中，請稍候',
        allowOutsideClick: false,
        heightAuto: false,
        willOpen: () => {
          vm.$swal.showLoading();
        }
      });

      const members_uuid = _.map(vm.memberList, (val) => val.member_line_uuid || val.line_uuid);

      vm.$store.dispatch('sm_group_push/multicastSendHandler', {
        to: members_uuid,
        messages: [
          data
        ]
      })
        .then(() => {
          vm.$snotify.success(null, '訊息送出成功');
          vm.$swal.close();
        });
    },
    // 移除要推播的顧客
    deletePushMemberHandler(member_id) {
      const vm = this;
      const key = _.findKey(vm.memberList, (val) => val.member_id === member_id);
      if (!key) return;
      vm.$store.commit('sm_group_push/removeMemberList', key);
    }
  },
  computed: {
    ...mapState({
      memberList: (state) => state.sm_group_push.memberList
    })
  },
  beforeRouteLeave(to, from, next) {
    const vm = this;
    vm.$store.commit('sm_group_push/resetHandler');
    next();
  }
};
</script>

<style lang="scss" scoped>
.searchArea {
  &__iconArrow {
    position: absolute;
    right: 10px;
    top: 5px;
    outline: none;
    transform: rotate(0deg);
    transition: all .3s;
  }
  &__iconArrow.collapsed {
    transform: rotate(180deg);
  }
}
</style>
